import React from 'react';
import {
  Container
} from 'reactstrap';

const PartnerCTA = () => {
  return (
    <section className="partner-text-section bg-black text-center text-white">
      <Container>
        <h2 className="partner-heading mb-3">Partner With ApexCXOs</h2>
        <p className="partner-text fs-5 mb-4">Strategic partnerships. Real impact.</p>
        <a href="/partner-with-us" className="btn btn-partner">
          Partner With Us
        </a>
      </Container>
    </section>
  );
};

export default PartnerCTA;